module.exports = __webpack_public_path__ + "img/booking-not-active-icon.ed9064b4.svg";